import React, { useEffect } from 'react'
import defaultProfilePicture from '../../assets/images/default_profile_picture.png'
import { useAsyncOperation } from '../../hooks/useAsyncOperation'
import { UserService } from '../../apilibrary'
import Box from '../../components/box'
import Typography, { TypographyColor } from '../../components/typography'
import Button from '../../components/button'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import Link from '../../components/router/link'
import { trackProfilePictureUpdate } from '../../utils/analytics'

interface BasicInfoFragmentProps {
  userId: string
}

const BasicInfoFragment: React.FC<BasicInfoFragmentProps> = ({
  userId
}) => {
  const [profileUrl, setProfileUrl] = React.useState<string>(defaultProfilePicture)
  const {
    item: profile,
    runFunction: getProfile
    // loading: loadingGetProfile
  } = useAsyncOperation(UserService.getUserProfileByUserId)
  const loggedInUserId = useCurrentUserId()

  useEffect(() => {
    void getProfile(userId)
  }, [getProfile, userId])

  useEffect(() => {
    console.log('profile', profile)
    const updateProfilePictureUrl = async (): Promise<void> => {
      if (!profile?.profilePicture) {
        setProfileUrl(defaultProfilePicture)
        return
      }
      const url = await profile.profilePicture.getPublicUrl()
      console.log('url: ', url)
      setProfileUrl(url)
      await trackProfilePictureUpdate(url, loggedInUserId)
    }
    void updateProfilePictureUrl()
  }, [loggedInUserId, profile])

  return (
    <Box display={'flex'} flexDirection={{
      xs: 'column',
      sm: 'row'
    }} justifyContent={'space-between'}
    gap={{
      xs: 2,
      sm: 4
    }}
    >
      <Box display={'flex'} gap={2}>
        <img style={{
          borderRadius: '8px',
          display: 'inline-block',
          width: '200px',
          height: '200px'
        }} src={profileUrl} alt="profile" />
        <Box display={'flex'} flexDirection={'column'}>
          <Typography variant='h1'>{profile?.firstName} {profile?.lastName}</Typography>
          {profile?.website && (
            <a href={profile.website} target='_blank' style={{ textDecoration: 'none' }} rel='noreferrer noopener'>
              <Typography color={TypographyColor.SECONDARY} variant='body1'>{profile.website}</Typography>
            </a>
          )}
          <Typography variant='body1'>{profile?.bio}</Typography>
        </Box>
      </Box>
      {loggedInUserId === userId && (
        <Box justifySelf={'flex-end'}>
          <Link to={'/settings/profile'}><Button variant='outlined' fullWidth>Edit profile</Button></Link>
        </Box>
      )}
    </Box>
  )
}

export default BasicInfoFragment
